module.exports = __webpack_public_path__ + "static/img/ktcu-cs-competition.bb81480.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/ktcu-cs-competition.jpg
// module id = 3qCG
// module chunks = 0